import { render, staticRenderFns } from "./TextEditorComponents.vue?vue&type=template&id=2d4d630e&"
import script from "./TextEditorComponents.vue?vue&type=script&lang=js&"
export * from "./TextEditorComponents.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorComponents.vue?vue&type=style&index=0&id=2d4d630e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports